<section class="flex justify-center p-12" [class.hidden]="!suppliers().length">
    <div class="flex flex-col gap-2">
        <packbo-package-badge [package]="package()" [prefix]="'supplier.member' | transloco" />

        <h3 class="lg:text-display-small text-title-large text-center">
            {{ supplierShowcaseBlock().translations_refs | getTranslation: "title" }}
        </h3>
    </div>
</section>

<packbo-supplier-carousel [suppliers]="suppliers()" />
